import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29b1d686"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seat posted" }, null, -1 /* HOISTED */))
const _hoisted_3 = ["onContextmenu"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["browse", $setup.config.browseType])
  }, [
    ($setup.config.browseTop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["browseTop"], { class: "nav-top" }),
          _hoisted_2
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "middle",
      onContextmenu: _withModifiers($setup.context_menu, ["prevent"])
    }, [
      _createVNode(_component_router_view)
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3),
    _hoisted_4
  ], 2 /* CLASS */))
}